<template>
  <div class="zyc-content-title-div">
    <div class="zyc-content-title">
      <h3><span><slot></slot></span></h3>
      <div class="zyc-content-title-rigth" v-if="rightItem">
        <template v-for="i in rightItem">
          <el-tooltip class="item" effect="dark" :ref="ref" :content="i.title" placement="top" :append-to-body="false">
            <div :class="'zyc-content-title-rigth-item '+ i.icon" @click="i.onclick">
            </div>
          </el-tooltip>
        </template>
      </div>
    </div>
    <div :id="id1"></div>
  </div>
</template>
<script>
  /**
  * 标题容器
  */
  export default {
    name: 'zycTitle',
    props: {
      rightItem: Array,
      default: []
    },
    model: {
    },
    watch: {
      rightItem(val) {
        console.log(val)
        this.$forceUpdate()
      }
    },
    data() {
      return {
        ref: Math.random().toString(36).slice(2),
        id1: Math.random().toString(36).slice(2),
      }
    },
    mounted() {
      if (this.$refs[this.ref]) {
        this.$refs[this.ref].forEach(i => {
          $('#' + this.id1).append(i.popperVM.$el)
        })
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/container/titleContainer.vue